import {
  TasksMyTodoCompletableByDateDataQuery,
  TasksMyTodoCompletableByDateDataQueryVariables,
} from 'graphql-common';
import { LazyQueryExecFunction } from '@apollo/client/react';
import { addDaysFn, endOfDayFn } from '@lib/utils/dateTimeHelpers';

export const fetchCompletableTasks = (
  fetchTasksMyTodoCompletableByDateData: LazyQueryExecFunction<
    TasksMyTodoCompletableByDateDataQuery,
    TasksMyTodoCompletableByDateDataQueryVariables
  >,
  syncTrackerDays: number,
) => {
  return fetchTasksMyTodoCompletableByDateData({
    variables: {
      date: syncTrackerDays
        ? addDaysFn(endOfDayFn(new Date()), +syncTrackerDays)
        : endOfDayFn(new Date()),
    },
  });
};
